import { NavLink } from 'react-router-dom';
import { Plane } from 'lucide-react';

const links = [['/', 'Dashboard'], ['/flights', 'Flights'], ['/aircraft', 'Aircraft'], ['/settings', 'Settings']] as const;

export default function Nav() {
  return (
    <header className="border-b border-line bg-panel/80 backdrop-blur sticky top-0 z-20">
      <div className="mx-auto max-w-[1600px] px-4 h-12 flex items-center gap-6">
        <div className="flex items-center gap-2 font-semibold tracking-tight"><Plane className="h-4 w-4 text-amber" /> KCCR Tracker</div>
        <nav className="flex gap-1 text-sm">
          {links.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => `px-3 py-1.5 rounded-md ${isActive ? 'bg-line text-fog' : 'text-dim hover:text-fog'}`}>{label}</NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
